import React from 'react'
import { object, func } from 'prop-types'
import { translate } from 'react-i18next'
import moment from 'moment'

export const RewardItemComponent = ({ reward, t }) => {
  return <div className='rewards__present__section'>
    <p className='rewards__present__section__description'>{reward.description}</p>
    <p className='rewards__present__section__date'>{t('common:account:rewards:used_points_date', {
      points: reward.points,
      date: moment(reward.createdDate).format('DD MMMM YYYY')
    })}</p>
  </div>
}

RewardItemComponent.propTypes = {
  t: func,
  reward: object
}

export const RewardItem = translate()(RewardItemComponent)



// WEBPACK FOOTER //
// ./src/components/customer/rewards/RewardItem.js